import { render, staticRenderFns } from "./TransactionPendingModal.vue?vue&type=template&id=71f3f2ae&scoped=true&"
import script from "./TransactionPendingModal.vue?vue&type=script&lang=js&"
export * from "./TransactionPendingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3f2ae",
  null
  
)

export default component.exports